module.exports = __webpack_public_path__ + "img/mainImg.4e5ce7f8.png";